'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRegisterableFeiseannaForSchool = exports.getFeiseannaForSchool = exports.getAllSchools = exports.getSchool = exports.getStudentsResults = exports.getScores = exports.getRegistrations = exports.getCompetitorsForSchool = undefined;

var _middleware = require('../../middleware');

var _getCompetitorsForSchool2 = require('./getCompetitorsForSchool');

var _getCompetitorsForSchool3 = _interopRequireDefault(_getCompetitorsForSchool2);

var _getRegistrations2 = require('./getRegistrations');

var _getRegistrations3 = _interopRequireDefault(_getRegistrations2);

var _getScores2 = require('./getScores');

var _getScores3 = _interopRequireDefault(_getScores2);

var _getStudentsResults2 = require('./getStudentsResults');

var _getStudentsResults3 = _interopRequireDefault(_getStudentsResults2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.getCompetitorsForSchool = _getCompetitorsForSchool3.default;
exports.getRegistrations = _getRegistrations3.default;
exports.getScores = _getScores3.default;
exports.getStudentsResults = _getStudentsResults3.default;
var getSchool = exports.getSchool = function getSchool(sid) {
  return function (dispatch, getState) {
    var school = getState().getIn(['schools', 'one', sid]);

    // prefer the cached version
    if (school) return;

    return dispatch(_defineProperty({
      sid: sid

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/schools/' + sid
      },
      types: ['GET_SCHOOL_START', 'GET_SCHOOL', 'GET_SCHOOL_ERROR']
    }));
  };
};

var getAllSchools = exports.getAllSchools = function getAllSchools() {
  return function (dispatch, getState) {
    var schools = getState().getIn(['schools', 'all']);

    // prefer the cached version
    if (schools) return;

    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/schools'
      },
      types: ['GET_ALL_SCHOOLS_START', 'GET_ALL_SCHOOLS', 'GET_ALL_SCHOOLS_ERROR']
    }));
  };
};

var getFeiseannaForSchool = exports.getFeiseannaForSchool = function getFeiseannaForSchool(sid) {
  return function (dispatch, getState) {
    var feiseanna = getState().getIn(['schools', 'feiseanna', sid, 'released']);

    // prefer the cached version
    if (feiseanna) return;

    return dispatch(_defineProperty({
      sid: sid

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/schools/' + sid + '/feiseanna'
      },
      types: ['GET_RELEASED_FEISEANNA_FOR_SCHOOL_START', 'GET_RELEASED_FEISEANNA_FOR_SCHOOL', 'GET_RELEASED_FEISEANNA_FOR_SCHOOL_ERROR']
    }));
  };
};

var getRegisterableFeiseannaForSchool = exports.getRegisterableFeiseannaForSchool = function getRegisterableFeiseannaForSchool(sid) {
  return function (dispatch, getState) {
    var feiseanna = getState().getIn(['schools', 'feiseanna', sid, 'registration']);

    // prefer the cached version
    if (feiseanna) return;

    return dispatch(_defineProperty({
      sid: sid

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/schools/' + sid + '/registerable-feiseanna'
      },
      types: ['GET_REGISTRABLE_FEISEANNA_FOR_SCHOOL_START', 'GET_REGISTRABLE_FEISEANNA_FOR_SCHOOL', 'GET_REGISTRABLE_FEISEANNA_FOR_SCHOOL_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/schools/index.js
// module id = 68
// module chunks = 0